export function getFileURL(file: { aws_key: string }) {
  return "/api/file/" + file.aws_key;
}
